import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $('form').bootstrapMaterialDesign();
  }

  switchDirectDebitType(event) {
    const type = event.target.value;

    if (type == "bankaccount") {
      $(".bank-account-container").show();
      $(".credit-card-container").hide();
    } else {
      $(".bank-account-container").hide();
      $(".credit-card-container").show();
    }
  }
}
